import { RcClasses } from '../../../../../foundation';
export var RcPlainSelectInputClasses = RcClasses(['root', 'input'], 'RcPlainSelectInput');
export var RcPlainSelectTouchRippleClasses = RcClasses(['child', 'root'], 'RcPlainSelect-TouchRipple');
export function switchVariantToButtonVariant(variant) {
    switch (variant) {
        case 'plainIcon':
            return 'plain';
        case 'round':
            return 'text';
        default:
            return variant;
    }
}
